import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Cognito from "./cognito/cognito";
import config from "./config";

//let _cognito = new Cognito()

createApp(App).use(Cognito, config).use(router).mount("#app");
